<template>
  <div class="l-page l-page--condition">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">
            保存している配信条件の一覧
          </div>
        </h2>
        <large-blue-button text="新しく配信条件を作る" @click="onAddClick" />
      </div>
      <div class="l-main-content">
        <div class="p-message-select-condition-list-type">
          <div class="c-tab">
            <ul class="c-tab-list">
              <li
                class="c-tab-list__item"
                :class="isSegment ? '' : 'is-active'"
                data-type="standard"
                @click="onStandardTabClick"
              >
                基本的な条件
              </li>
              <!-- <li class="c-tab-list__item" data-type="advanced">より高度な条件を設定する</li> -->
              <li
                class="c-tab-list__item"
                :class="isSegment ? 'is-active' : ''"
                data-type="segment"
                @click="onSegmentTabClick"
              >
                属性データの条件
              </li>
            </ul>
          </div>
        </div>
        <condition-list v-show="!isSegment" :condition-info="conditionInfo" />
        <topic-condition-list v-show="isSegment" :condition-info="conditionInfo" />
      </div>
    </main>
  </div>
</template>

<script>
import 'axios';

export default {
  props: {
    conditionInfo: Object,
  },
  data () {
    return {
      addServiceTypes: [],
      messageTypes: [],
      serviceTypes: [],
      isSegment: false,
    }
  },
  mounted: function() {
    import('../../funcs/pages/condition').then(module => {
      module.Condition();
    });
    if (location.hash === '#segment') {
      this.isSegment = true;
    }
  },
  methods: {
    onStandardTabClick: function() {
      this.isSegment = false;
      location.hash = '#standard';
    },
    onSegmentTabClick: function() {
      this.isSegment = true;
      location.hash = '#segment';
    },
    onAddClick: function() {
      location.href = this.conditionInfo.addUrl;
    },
  }
}
</script>
